import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import ProposalSendForm from './ProposalSendForm';
import ProposalBidsTable from './ProposalBidsTable';
import BrandContactsExpandCollapse from './BrandContactsExpandCollapse';
import { Tabs, Tab, Nav, Row, Col } from 'react-bootstrap';
import { Button, Badge, Label } from 'react-bootstrap';
import { displayBuyerBidState } from '../../../core/api';

function formatContactData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    value: item.id,
  }));
}

function getInitialValues(jsonObject) {
  return jsonObject.map(item => (item.id));
}

function findById(value) {
  return value.id === Number(this);
}

class RequestBidsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedContactList: [],
      checkedBrandContacts: [],
      isDisable: true,
      activeTab: this.props.active,
      activateKey : this.props.activateKey,
      showPopUp:false,
      newContactsList:null,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleContactData = this.handleContactData.bind(this);
    this.handleBrandContactData = this.handleBrandContactData.bind(this);
    this.handleSendBidRequests = this.handleSendBidRequests.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.ContactPopUpShow = this.ContactPopUpShow.bind(this);
    this.ContactPopupHide = this.ContactPopupHide.bind(this);
    this.updateProposalState = this.updateProposalState.bind(this);
  }
  handleTabClick(key) {
    if (this.props.proposal.brand.name){
      this.setState({
        activeTab: key
      });
    } else{
      this.setState({
        activeTab: 'hotel'
      });
    }
  }
  handleSubmit(values) {
    this.props.sendProposal(
      this.props.proposal.id,
      values,
      this.state.activeTab,(response)=>{console.log('contact added')}
    );
    if(this.state.activeTab !== 'hotel'){
      this.props.close();
    }
  }
  handleContactData(contactData, checked) {
    let checkedContacts = this.state.checkedContactList;
    if(checked) {
      checkedContacts.push(contactData);
    }else {
      let contactId = contactData.id;
      const idx = checkedContacts.findIndex(findById, contactId);
      checkedContacts.splice(idx, 1);
    }
    this.setState({
      checkedContactList: checkedContacts
    })
    if(checkedContacts.length){
      this.setState({
        isDisable: false
      })
    }else{
      this.setState({
        isDisable: true
      })
    }
  }
  handleBrandContactData(brandContactData, checked) {
    let checkedBrandContactsList = this.state.checkedBrandContacts;
    if(checked) {
      checkedBrandContactsList.push(brandContactData);
    }else {
      let contactId = brandContactData.id;
      const idx = checkedBrandContactsList.findIndex(findById, contactId);
      checkedBrandContactsList.splice(idx, 1);
    }
    this.setState({
      checkedBrandContacts: checkedBrandContactsList
    })
  }
  handleSendBidRequests() {
      
    const sendNewProposalBtnForHotel = document.getElementById('sendProposalForHotel');
    // if(this.state.activateKey){
    // sendNewProposalBtnForHotel.click();
    // }

    this.setState({
      isDisable: true
    })
    let contactData = this.state.checkedContactList;
    let bidData = [];
    const bids = [...new Set(contactData.map(contact => contact.bid_id))]
    for(let i=0; i<bids.length; i++){
      let contacts = [];
      contactData.forEach((obj)=>{
        if(obj.bid_id == bids[i]) {
          contacts.push({'id':obj.id, 'name':obj.name, 'email':obj.email})
        }
      })
      bidData.push({'bid_id': bids[i], 'contacts': contacts})
    }
    const payload = {bidContactData: bidData, brandContacts: this.state.checkedBrandContacts}
    this.props.sendHotelBidRequests(payload, (response) => {
      console.log("bid response data",response)
      this.setState({
        isDisable: false
      })
       
      this.props.close();
    });
  }
  ContactPopUpShow(){
    this.setState({showPopUp:true});
  }
  ContactPopupHide(){
    this.setState({showPopUp:false});
  }
  updateProposalState(val){
    const data = val;
    this.setState({newContactsList:data})
    this.props.existingValue(data);
  }
  render() {
    const newContactsList = this.state.newContactsList;
    const existVal = this.props.existVal;
    const initialValues = { contacts: getInitialValues(this.props.proposal.contacts) };
    const mergedContacts = Array.from(
        new Set(
          this.props.proposal.saved_brand_contacts.concat(
            this.props.proposal.contacts,
          ),
        ),
      );
    const newContact = newContactsList?newContactsList:existVal?existVal:mergedContacts;
    const contactOptions = formatContactData(newContact);

    let name = 'Unbranded';
    if (this.props.proposal.brand) {
      name = this.props.proposal.brand.name;
    }
    const bids = this.props.proposal.bids;
    const status = {};
    status.sent = 0;
    status.pending = 0;
    for (let i = 0, len = bids.length; i < len; i++) {
      if(bids[i].bidset){
        const displayState = displayBuyerBidState(bids[i].buyer_state, bids[i].bidder_state);
        if (['Sent', 'Sending'].includes(displayState)) {
          status.sent += 1;
        }
        if (['Draft'].includes(displayState)) {
          status.pending += 1;
        }
      }
    }
    return (
      <Modal bsSize="large" show={this.props.show} onHide={this.props.close}  backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Request Bids</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="request-bids-modal-tabs">
        {this.state.activateKey?(
          <Tabs defaultActiveKey={this.state.activeTab} mountOnEnter={true} onSelect={this.handleTabClick}>
            <Tab eventKey="brand" title="Request Bid from Brand">
              <p>Send the bid request to your {this.props.brand} sales rep.</p>
              <ProposalSendForm
                onSubmit={this.handleSubmit}
                initialValues={initialValues}
                options={contactOptions}
                proposal={this.props.proposal}
                showPopUp={this.state.showPopUp}
                ContactPopUpShow={this.ContactPopUpShow}
                ContactPopupHide={this.ContactPopupHide}
                brandContacts={newContact}
                HotelBrandContactUpdate={this.props.HotelBrandContactUpdate}
                HotelBrandContactDelete={this.props.HotelBrandContactDelete}
                updateProposalState={this.updateProposalState}
                sendProposal={this.props.sendProposal}
                tab='brand'
              />
            </Tab>
            <Tab eventKey="hotel" title="Request Bid from Hotel" mountOnEnter>
              <h3>
                {name}&nbsp;&nbsp;
                {status.pending !== 0 && <Badge bsStyle="info">{status.pending}</Badge>}
                &nbsp;&nbsp;<span className="sent-icon-indication-text">Sent to contact – ( <i className="fa fa-check bid-request-sent-icon" aria-hidden="true"></i> )</span>
              </h3>
              { (this.props.status.pending !== 0) && (
                <p><strong>{this.props.status.pending} requests need to be sent.</strong></p>
              )}
              <ProposalBidsTable
                proposal={this.props.proposal}
                addHotelContact={this.props.addHotelContact}
                handleContactData={this.handleContactData}
                HotelContactDelete={this.props.HotelContactDelete}
                HotelContactUpdate={this.props.HotelContactUpdate}
              />
              <BrandContactsExpandCollapse
                proposal={this.props.proposal}
                activateKey={this.state.activateKey}
                handleBrandContactData={this.handleBrandContactData}
                addBrandContact={this.props.addBrandContact}
                handlePropasalRequest={this.handleSubmit}
                showPopUp={this.state.showPopUp}
                ContactPopUpShow={this.ContactPopUpShow}
                ContactPopupHide={this.ContactPopupHide}
                brandContacts={newContact}
                HotelBrandContactUpdate={this.props.HotelBrandContactUpdate}
                HotelBrandContactDelete={this.props.HotelBrandContactDelete}
                updateProposalState={this.updateProposalState}
                sendProposal={this.props.sendProposal}
                newContact={newContact}
                contactOptions={contactOptions}
              />
              <Button title="Send" disabled={this.state.isDisable} bsStyle="success" onClick={this.handleSendBidRequests} className="hotel-bid-requests-send-btn">
                  <i className="fa fa-envelope fa-lg" />
                  <i className="fa fa-email fa-lg" /> Send
              </Button>
            </Tab>
          </Tabs>):(
          <Tabs defaultActiveKey={this.state.activeTab} mountOnEnter={true} onSelect={this.handleTabClick}>
            <Tab eventKey="hotel" title="Request Bid from Hotel" mountOnEnter>
              <h3>
                {name}&nbsp;&nbsp;
                {status.pending !== 0 && <Badge bsStyle="info">{status.pending}</Badge>}
                &nbsp;&nbsp;<span className="sent-icon-indication-text">Sent to contact – ( <i className="fa fa-check bid-request-sent-icon" aria-hidden="true"></i> )</span>
              </h3>
              { (this.props.status.pending !== 0) && (
                <p><strong>{this.props.status.pending} requests need to be sent.</strong></p>
              )}
              <ProposalBidsTable
                proposal={this.props.proposal}
                addHotelContact={this.props.addHotelContact}
                handleContactData={this.handleContactData}
                HotelContactDelete={this.props.HotelContactDelete}
                HotelContactUpdate={this.props.HotelContactUpdate}
              />
              <Button title="Send" disabled={this.state.isDisable} bsStyle="success" onClick={this.handleSendBidRequests} className="hotel-bid-requests-send-btn">
                  <i className="fa fa-envelope fa-lg" />
                  <i className="fa fa-email fa-lg" /> Send
              </Button>
            </Tab>
          </Tabs>
          )}
        </div>
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

RequestBidsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  proposal: PropTypes.object.isRequired,
  sendProposal: PropTypes.func.isRequired,
  existingValue: PropTypes.func.isRequired,
};

RequestBidsModal.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default RequestBidsModal;



// WEBPACK FOOTER //
// src/routes/tours/components/RequestBidsModal.js